import { validateRadarVehicle } from "./homepagePassengerRadar";
export type SavedDriverVehicle = { type: string; name: string; number: string };
// This preference is a convenience only. Ride acceptance still validates the
// actual vehicle through the existing authenticated ride-request transaction.
export function parseSavedDriverVehicle(input: unknown): SavedDriverVehicle {
  if (!input || typeof input !== "object") throw new Error("Enter vehicle type, model and registration.");
  const value = input as Record<string, unknown>;
  if (typeof value.type !== "string" || typeof value.name !== "string" || typeof value.number !== "string") {
    throw new Error("Enter vehicle type, model and registration.");
  }
  const vehicle = { type: value.type, name: value.name.trim(), number: value.number.trim().toUpperCase() };
  validateRadarVehicle({ ...vehicle, radius: "25" });
  return vehicle;
}
